import { motion } from "framer-motion";
import { HeartPulse, Loader2, Sparkles } from "lucide-react";
import { Button } from "../ui/button";
import { PremiumLock } from "../PremiumFeatures";
import HealthForecast from "../HealthForecast";
import WhatToWear from "../WhatToWear";
import { WindAtmosphereCard } from "./WindAtmosphereCard";

export function DashboardTopCards({
  item,
  isWidgetVisible,
  isPremium,
  location,
  weather,
  forecast,
  healthData,
  aiSummary,
  generateAiSummary,
  loadingAi,
  LocalTimeCard,
  convertTemp,
  tempSymbol,
}) {
  return (
    <>
      <motion.div variants={item} className="col-span-1 row-span-1 glass rounded-3xl p-4 sm:p-5 relative overflow-hidden" data-testid="ai-summary-card">
        <div className="absolute top-0 right-0 w-32 h-32 bg-[#7000ff]/10 rounded-full blur-2xl pointer-events-none" />
        <div className="flex items-center gap-2 mb-3">
          <Sparkles className="w-5 h-5 text-[#7000ff]" />
          <h3 className="font-semibold">AI Insights</h3>
        </div>
        {aiSummary ? (
          <p className="text-sm text-white/70 leading-relaxed line-clamp-5">{aiSummary}</p>
        ) : (
          <Button onClick={generateAiSummary} disabled={loadingAi || !forecast} data-testid="generate-ai-summary-btn" className="w-full bg-[#7000ff]/20 hover:bg-[#7000ff]/30 border border-[#7000ff]/30 rounded-xl text-xs sm:text-sm">
            {loadingAi ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Sparkles className="w-4 h-4 mr-2" />}
            <span className="truncate">Generate Summary</span>
          </Button>
        )}
      </motion.div>

      <LocalTimeCard location={location} timezone={weather?.timezone} />

      {isWidgetVisible('health') && (
        <motion.div variants={item} className="col-span-1 row-span-1 glass rounded-3xl p-3 sm:p-5" data-testid="health-top-card">
          <PremiumLock feature="Health & Activity Forecast" canAccess={isPremium}>
            <div className="flex items-center gap-2 mb-4">
              <HeartPulse className="w-5 h-5 text-[#ff0080]" />
              <h3 className="font-semibold text-white/80">Health & Activity</h3>
            </div>
            <HealthForecast data={healthData} />
          </PremiumLock>
        </motion.div>
      )}

      {weather && (
        <motion.div variants={item} className="col-span-1 row-span-1 glass rounded-3xl p-3 sm:p-5" data-testid="what-to-wear-top-card">
          <WhatToWear weather={weather} forecast={forecast} />
        </motion.div>
      )}

      {isWidgetVisible('wind') && weather && (
        <WindAtmosphereCard item={item} weather={weather} convertTemp={convertTemp} tempSymbol={tempSymbol} />
      )}
    </>
  );
}